(function () {
  if (customElements.get('atiq54-color-strip')) return;
  class Atiq54ColorStrip extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.controller = new AbortController();
      this.prev.addEventListener('click', () => this.move(-1), { signal: this.controller.signal });
      this.next.addEventListener('click', () => this.move(1), { signal: this.controller.signal });
      this.track.addEventListener('scroll', () => this.updateButtons(), { signal: this.controller.signal, passive: true });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault();
        this.move(e.key === 'ArrowRight' ? 1 : -1);
      }, { signal: this.controller.signal });
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.updateButtons());
        this.resize.observe(this.track);
      }
      this.load();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.resize?.disconnect();
      this.ready = false;
    }
    normalize(s) {
      return (s || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
    }
    async load() {
      const id = this.dataset.productId;
      const title = this.dataset.productTitle;
      const found = new Set([id]);
      const visited = new Set();
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      let url = new URL(this.dataset.searchUrl, location.origin);
      url.searchParams.set('q', '"' + title + '"');
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'none');
      url.searchParams.set('options[unavailable_products]', 'last');
      url.searchParams.set('section_id', 'atiq-color-results');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        let pages = 0;
        while (url && pages < 5 && this.isConnected) {
          if (url.origin !== location.origin || visited.has(url.href)) break;
          visited.add(url.href);
          const response = await fetch(url.href, { credentials: 'same-origin', signal: this.controller.signal });
          if (!response.ok) throw new Error('Colours unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = doc.querySelector('[data-atiq-color-results]');
          if (!results) throw new Error('Missing colour results');
          for (const card of results.querySelectorAll('[data-color-product-id]')) {
            const otherId = card.dataset.colorProductId;
            if (!otherId || found.has(otherId) || this.normalize(card.dataset.colorProductTitle) !== this.normalize(title)) continue;
            const source = card.querySelector('a');
            if (!source) continue;
            found.add(otherId);
            const name = card.querySelector('.atiq-color-card__name')?.textContent.trim() || title;
            const link = document.createElement('a');
            link.className = 'atiq54-color-strip__item';
            if (card.querySelector('.atiq-color-card__badge')) link.classList.add('is-unavailable');
            const destination = new URL(source.getAttribute('href'), location.origin);
            if (destination.origin !== location.origin) continue;
            if (preview) destination.searchParams.set('preview_theme_id', preview);
            link.href = destination.href;
            link.title = name;
            link.setAttribute('aria-label', name);
            const media = document.createElement('span');
            media.className = 'atiq54-color-strip__imagebox';
            const sourceImage = card.querySelector('img');
            if (sourceImage) {
              const img = sourceImage.cloneNode(false);
              img.className = 'atiq54-color-strip__image';
              img.loading = 'lazy';
              img.sizes = '(max-width: 699px) 56px, 64px';
              img.alt = name;
              img.removeAttribute('style');
              media.appendChild(img);
            } else {
              const fallback = document.createElement('span');
              fallback.textContent = name.slice(0, 2);
              media.appendChild(fallback);
            }
            link.appendChild(media);
            this.track.appendChild(link);
          }
          url = null;
          if (results.dataset.nextUrl) {
            url = new URL(results.dataset.nextUrl, location.origin);
            url.searchParams.set('section_id', 'atiq-color-results');
            if (preview) url.searchParams.set('preview_theme_id', preview);
          }
          pages++;
        }
        if (this.track.children.length > 1 && this.isConnected) {
          this.hidden = false;
          this.updateButtons();
        }
      } catch (e) {
        if (e.name !== 'AbortError') {
          this.hidden = true;
        }
      }
    }
    move(direction) {
      const first = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = first ? first.getBoundingClientRect().width + gap : 60;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({ left: direction * distance * 3 * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateButtons() {
      const box = this.track.getBoundingClientRect();
      const items = this.track.children;
      if (!items.length) return;
      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();
      const overflow = this.track.scrollWidth > this.track.clientWidth + 3;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.prev.disabled = !overflow || (rtl ? first.right <= box.right + 3 : first.left >= box.left - 3);
      this.next.disabled = !overflow || (rtl ? last.left >= box.left - 3 : last.right <= box.right + 3);
    }
  }
  customElements.define('atiq54-color-strip', Atiq54ColorStrip);
})();